import { css } from '@emotion/react';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Heading, SpinningLoader, Text } from '@frontend/design-system';

type SelectionFilterProps = {
  label: string;
  value: string;
  iconName: IconName;
  iconColor: string;
  isSelected: boolean;
  onClick: () => void;
  isLoading?: boolean;
};

export const SelectionFilter = ({
  label,
  value,
  iconName,
  iconColor,
  isSelected,
  onClick,
  isLoading,
}: SelectionFilterProps) => {
  return (
    <section onClick={onClick} css={selectionFilterStyles(isSelected)}>
      <Text weight='bold' size='medium' css={{ marginBottom: theme.spacing(1) }}>
        {label}
      </Text>
      <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {isLoading ? <SpinningLoader size='small' /> : <Heading level={3}>{value}</Heading>}
        <Icon name={iconName} size={24} css={{ color: iconColor }} />
      </div>
    </section>
  );
};

const selectionFilterStyles = (isSelected: boolean) =>
  css({
    backgroundColor: isSelected ? theme.colors.primary5 : theme.colors.white,
    border: `1px solid ${isSelected ? theme.colors.primary60 : theme.colors.neutral20}`,
    cursor: 'pointer',
    padding: theme.spacing(2),
    borderRadius: theme.borderRadius.medium,
    flex: 1,
  });
